module.exports = __webpack_public_path__ + "static/media/pdf.fbd2ab6d.svg";